<template>
  <div>

  <el-container style="height: 100vh; border: 1px solid #eee">
    <el-aside width="230px" style="background-color: rgb(238, 241, 246)">
      <el-menu 
        router 
        :default-active="$route.path" 
        :default-openeds="openeds"
        unique-opened
      >
        <!-- 首页 -->
        <el-menu-item index="/home">
          <i class="el-icon-price-tag"></i>首页
        </el-menu-item>
        <!-- 根据角色显示人员管理 -->
        <el-submenu v-if="isAdmin || isEmployee" index="2">
          <template slot="title"><i class="el-icon-s-custom"></i>人员管理</template>
          <el-menu-item v-if="isAdmin" index="/user/create">添加人员</el-menu-item>
          <el-menu-item v-if="isAdmin" index="/user/list">人员列表</el-menu-item>
          <el-menu-item v-if="isAdmin || isEmployee" index="/user-signin">人员签到管理</el-menu-item>
        </el-submenu>

        <!-- 访客管理 -->
        <el-submenu v-if="isAdmin || isEmployee" index="3">
          <template slot="title"><i class="el-icon-news"></i>访客管理</template>
          <el-menu-item v-if="isAdmin || isEmployee" index="/order/create">访客预约</el-menu-item>
          <el-menu-item v-if="isAdmin || isEmployee" index="/order/list">访客列表</el-menu-item>
          <el-menu-item v-if="isAdmin || isEmployee" index="/order-signin">访客签到管理</el-menu-item>
        </el-submenu>

        <!-- 通行数据 -->
        <el-submenu v-if="isAdmin || isEmployee" index="4">
          <template slot="title"><i class="el-icon-coin"></i>通行数据</template>
          <el-menu-item v-if="isAdmin || isEmployee" index="/user-transit">人员通行记录</el-menu-item>
          <el-menu-item v-if="isAdmin || isEmployee" index="/order-transit">访客通行数据</el-menu-item>
        </el-submenu>

        <!-- 系统管理 -->
        <el-submenu v-if="isAdmin" index="5">
          <template slot="title"><i class="el-icon-setting"></i>系统管理</template>
          <el-menu-item index="/writing">通知公告</el-menu-item>
          <el-menu-item index="/user-setting/:id">角色管理</el-menu-item>
          <el-menu-item index="/departmentManagement">部门管理</el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header style="text-align: right; font-size: 12px">
        <el-dropdown>
          <i class="el-icon-setting" style="margin-right: 15px"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span>访客门禁综合管理平台</span>
      </el-header>

      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
      
</div>
</template>

<script>
export default {
  data() {
    return {
      openeds: [],
      isAdmin: false,
      isEmployee: false,
      canAccessVisitorManagement: false
    };
  },
  created() {
    this.updateRole();
    this.$root.$on('reloadMenu', this.updateRole);
  },
  beforeDestroy() {
    this.$root.$off('reloadMenu', this.updateRole);
  },
  methods: {
    updateRole() {
      const role = localStorage.getItem('role');
      const username = localStorage.getItem('username'); // 获取当前登录的用户名

      if (role === 'admin') {
        this.isAdmin = true;
      } else if (role === 'employee') {
        this.isEmployee = true;
        // 检查是否是特定用户（如001）
        if (username === '001') {
          this.canAccessVisitorManagement = true;
        }
      }

      this.updateMenu();
    },
    updateMenu() {
      this.$nextTick(() => {
        const path = this.$route.path;
        if (path.startsWith('/user')) {
          this.openeds = ['2'];
        } else if (path.startsWith('/order')) {
          this.openeds = ['3'];
        } else if (path.startsWith('/user-transit') || path.startsWith('/order-transit')) {
          this.openeds = ['4'];
        } else if (path.startsWith('/writing') || path.startsWith('/user-setting')) {
          this.openeds = ['5'];
        } else {
          this.openeds = [];
        }
      });
    },
    logout() {
      localStorage.removeItem('role');
      localStorage.removeItem('username');
      this.isAdmin = false;
      this.isEmployee = false;
      this.canAccessVisitorManagement = false;
      this.$router.push('/login');
    }
  }
};
</script>

<style lang="less">
html,body{
  padding: 0;
  margin: 0;
}

.el-header {
  background-color: #B3C0D1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}
</style>